import React, { useMemo } from 'react';
import { BodyButton, Label } from './bodyStyle.style';
import {
  BodyTypeFilterResultCounts,
  FilterOption,
  FilterResultCounts,
  RangeResultsCounts,
} from '../../../types';
import { FilterTypes } from '../../../constants/initialFilters';
import { COLORS } from '../../../styles/variables';

type BodyType = keyof BodyTypeFilterResultCounts;
interface BodyTypes {
  body: BodyType;
  filterType: string;
  bodyTypeOptions: {
    [key: string]: FilterOption;
  };
  temporaryFilters: FilterTypes;
  availableFilters: {
    filterResults: FilterResultCounts;
    rangeResults: RangeResultsCounts;
  };
  handleAddFilter: (filterType: string, value: string) => void;
}

const Body: React.FC<BodyTypes> = ({
  body,
  filterType,
  bodyTypeOptions,
  temporaryFilters,
  availableFilters,
  handleAddFilter,
}) => {
  const {
    image: Image,
    selectedImage: SelectedImage,
    value,
    label,
  } = bodyTypeOptions[body] as {
    image: React.ComponentType<any>;
    selectedImage: React.ComponentType<any>;
    value: string;
    label: string;
  };

  const isSelected = temporaryFilters.bodyType.includes(value);

  const isAvailable = useMemo(() => {
    return !!availableFilters?.filterResults?.body_type[body]?.count;
  }, [availableFilters, body]);

  const handleAddBodyFilter = () => {
    if (!isAvailable) return;
    handleAddFilter(filterType, value);
  };

  return (
    <BodyButton
      type="button"
      key={value}
      onClick={handleAddBodyFilter}
      disabled={!isAvailable}
      data-testid={`body-cta-${body}`}
    >
      {isSelected ? (
        <SelectedImage />
      ) : (
        <Image color={isAvailable ? COLORS.black : COLORS.grey30} />
      )}
      <Label isSelected={isSelected} isAvailable={isAvailable}>
        {label}
      </Label>
    </BodyButton>
  );
};

export default Body;
